import store from '@/packages/vuex'
import { createNamespacedHelpers } from 'vuex'
import Departments from './index.js'

if (!store?.state?.['Departments']) {
	store.registerModule('Departments', Departments)
}

export const { mapActions, mapGetters, mapMutations, mapState } = createNamespacedHelpers('Departments')
